export type ApplicationSurface = 'main' | 'dashboard';

export class HostRoutingService {
  private readonly dashboardSubdomain = 'dashboard';

  getApplicationSurface(hostname: string, pathname = '/'): ApplicationSurface {
    return this.isDashboardHost(hostname) || this.isLocalDashboardPath(hostname, pathname) ? 'dashboard' : 'main';
  }

  isDashboardHost(hostname: string): boolean {
    const normalizedHostname = hostname.trim().toLowerCase().replace(/\.$/, '');

    return normalizedHostname === this.dashboardSubdomain || normalizedHostname.startsWith(`${this.dashboardSubdomain}.`);
  }

  private isLocalDashboardPath(hostname: string, pathname: string): boolean {
    const normalizedHostname = hostname.trim().toLowerCase().replace(/^\[|\]$/g, '');
    const isLocalHost = ['localhost', '127.0.0.1', '::1'].includes(normalizedHostname);

    return isLocalHost && pathname.replace(/\/+$/, '') === '/dashboard';
  }
}
